import { __ } from '@wordpress/i18n';
import { useState } from 'react';
import SbUtils from '../../../../Utils/SbUtils';

const WPConsentBanner = ({ sbCustomizer, editorNotification, editorTopLoader }) => {
    const [showLoader, setShowLoader] = useState(false);
    const wpConsent = sbCustomizer?.gdprInfo?.wpConsent || {};

    if (wpConsent?.pluginActive) {
        return null;
    }

    const isInstalled = wpConsent?.pluginInstalled;

    const ctaButtonText = isInstalled
        ? __('Activate WPConsent', 'sb-customizer')
        : __('Install WPConsent', 'sb-customizer');

    const installActivatePlugin = () => {
        setShowLoader(true);

        let plugin = 'https://downloads.wordpress.org/plugin/wpconsent-cookies-banner-privacy-suite.latest-stable.zip',
            action = 'install';

        if (isInstalled) {
            plugin = 'wpconsent-cookies-banner-privacy-suite/wpconsent.php';
            action = 'activate';
        }

        const formData = {
            action: action === 'install' ? 'sbtt_install_plugin' : 'sbtt_activate_plugin',
            plugin: plugin
        };

        const notificationsContent = {
            type: 'success',
            icon: 'success',
            text: action === 'install'
                ? __('Plugin Installed', 'sb-customizer')
                : __('Plugin Activated', 'sb-customizer')
        };

        SbUtils.ajaxPost(
            sbCustomizer.ajaxHandler,
            formData,
            (data) => {
                setShowLoader(false);
                if (data.success === false) {
                    // WordPress AJAX errors wrap the message in data.data[0]; unwrap if present.
                    data = data?.data[0] ?? data;
                    const errorNotification = {
                        type: 'error',
                        icon: 'notice',
                        text: data?.message ? data?.message : __('Unknown Error', 'sb-customizer')
                    };
                    SbUtils.applyNotification(errorNotification, editorNotification);
                } else {
                    SbUtils.applyNotification(notificationsContent, editorNotification);
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
            },
            editorTopLoader,
            null,
            null
        );
    };

    return (
        <div className='sb-wpconsent-banner'>
            <div className='sb-wpconsent-banner-left'>
                <div className='sb-wpconsent-banner-icon'>
                    <svg width='24' height='17' viewBox='0 0 24 16.62' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path d='M9.45 0.73C9.45 0.33 9.13 0.01 8.74 0H4.58C4.32 0 4.08 0.14 3.95 0.37L0.65 6.21C0.38 6.69 0.73 7.29 1.28 7.29H5.44C5.7 7.28 5.94 7.15 6.07 6.92L9.35 1.1C9.35 1.1 9.34 1.1 9.34 1.1C9.41 0.99 9.45 0.87 9.45 0.73Z' fill='#663D00'/>
                        <path d='M24 8.31C24 8.18 23.96 8.05 23.9 7.94L20 1.03L17.09 6.17L18.1 7.97C18.16 8.08 18.19 8.2 18.19 8.32C18.19 8.44 18.16 8.55 18.11 8.65L14.27 15.46C14.18 15.58 14.13 15.73 14.13 15.89C14.13 16.29 14.45 16.61 14.85 16.62H19.01C19.26 16.62 19.5 16.48 19.63 16.25L23.93 8.63C23.93 8.63 23.93 8.62 23.93 8.62C23.97 8.53 24 8.42 24 8.31Z' fill='#663D00'/>
                        <path d='M20 1.02L19.42 0L16.58 4.99L16.5 5.13L15.87 6.24C16 6.03 16.23 5.88 16.5 5.88C16.74 5.88 16.96 6 17.09 6.18V6.17L20 1.02Z' fill='#FFF7E5'/>
                        <path d='M14.07 0C14.07 0 14.07 0 14.07 0C14.06 0 14.05 0 14.05 0C13.76 0 13.51 0.17 13.4 0.41L7.75 10.4C7.62 10.62 7.38 10.77 7.11 10.77C6.83 10.77 6.58 10.61 6.46 10.38L5.5 8.68C5.37 8.45 5.13 8.31 4.87 8.31L0.72 8.33C0.17 8.33 -0.18 8.92 0.09 9.4L3.96 16.25C4.09 16.48 4.33 16.62 4.59 16.62H9.53C9.53 16.62 9.54 16.62 9.54 16.62C9.82 16.62 10.06 16.47 10.18 16.24C10.18 16.24 10.18 16.24 10.18 16.24L13.73 10.02L15.87 6.24L16.51 5.13L16.59 4.99L19.42 0H14.07Z' fill='#663D00'/>
                    </svg>
                </div>
                <div className='sb-wpconsent-banner-text'>
                    <p className='sb-wpconsent-banner-title'>
                        {__('Install WPConsent for GDPR', 'sb-customizer')}
                    </p>
                    <p className='sb-wpconsent-banner-desc'>
                        {__('Manage cookie banners and user permissions from a single place.', 'sb-customizer')}
                        <br />
                        {__('SmashBalloon plugins work great with WPConsent.', 'sb-customizer')}
                    </p>
                </div>
            </div>
            <button
                className='sb-wpconsent-banner-btn'
                onClick={installActivatePlugin}
                disabled={showLoader}
            >
                {showLoader
                    ? <span className='sb-wpconsent-spinner'></span>
                    : <svg className='sb-wpconsent-btn-icon' width='16' height='16' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path d='M10.88 1.47C9.87 0.64 8.63 0.13 7.33 0V1.35C8.31 1.47 9.19 1.85 9.93 2.43L10.88 1.47ZM11.95 5.97H13.3C13.17 4.63 12.63 3.41 11.83 2.42L10.87 3.37C11.46 4.12 11.83 5.02 11.95 5.97ZM10.87 9.9L11.83 10.85C12.66 9.84 13.17 8.61 13.3 7.31H11.95C11.83 8.25 11.46 9.15 10.87 9.9ZM7.33 11.92V13.27C8.67 13.13 9.89 12.6 10.88 11.79L9.93 10.84C9.19 11.41 8.31 11.8 7.33 11.92ZM9.06 5.69L7.33 7.41V3.3H6V7.41L4.27 5.69L3.33 6.63L6.67 9.97L10 6.63L9.06 5.69ZM6 11.92V13.27C2.63 12.93 0 10.09 0 6.63C0 3.17 2.63 0.33 6 0V1.35C3.37 1.67 1.33 3.91 1.33 6.63C1.33 9.35 3.37 11.59 6 11.92Z' fill='#141B38'/>
                    </svg>
                }
                {ctaButtonText}
            </button>
        </div>
    );
};

export default WPConsentBanner;
